var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-end justify-content-between"},[_c('div',{staticClass:"d-flex",staticStyle:{"gap":"5px"}},[_c('div',{staticClass:"d-flex align-items-start flex-column"},[_vm._t("options")],2),_c('div',{staticClass:"d-flex align-items-start flex-column"},[_vm._t("pagination")],2)]),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }